/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events,jsx-a11y/anchor-is-valid */
import * as _ from 'lodash';
import { Dropdown } from 'react-bootstrap';
import type { CSSProperties, VoidFunctionComponent } from 'react';
import { containEvent, stopEventPropagation } from '../../utils';
import SearchInput from './SearchInput';

export type Tab = {
  key: string; // unique value of the tab selection (used for unique identification of tab)
  label: string; // label for the tab selection
  contents: any; // body of the tab in the actual dropdown.
};

type DropdownBodyProps = {
  title?: string; // title at the top of the dropdown
  dropdownStyle?: CSSProperties;

  // Search Filter props
  filterEnabled?: boolean;
  filterPlaceHolderText?: string;
  filterValue?: string;
  onFilterChange?(value: string): void;

  // Tab props
  tabs: Tab[];
  helperTab?: any; // extra helper tab that will float:right
  selectedTab: string; // corresponds to the Tab.key
  onTabClick(tabValue: string): void;
};

const DropdownBody = (props: DropdownBodyProps) => {
  const currentTabContents = props.tabs.find(tab => tab.key === props.selectedTab)?.contents ?? 'Nothing to view here...';
  return (
    <div style={props.dropdownStyle}>
      {props.title &&
        <div>
          <div style={{ padding: '5px 10px' }}><b>{props.title}</b></div>
          <hr className="nomargin-v" />
        </div>}
      {props.filterEnabled && (
        <div style={{ margin: '10px' }}>
          <SearchInput
            placeholder={props.filterPlaceHolderText}
            value={props.filterValue}
            onClick={stopEventPropagation}
            onChange={(ev) => props.onFilterChange(ev.target.value)}
          />
        </div>
      )}
      <ul className="nav nav-tabs nav-tabs-condensed">
        {props.tabs.map(tab =>
          <li key={tab.key} className={props.selectedTab === tab.key ? 'active' : null}>
            <a className="clickable inline-block" onClick={containEvent(_.partial(props.onTabClick, tab.key))}>
              {tab.label}
            </a>
          </li>)}
        {props.helperTab &&
          <li className="pull-right">
            {props.helperTab}
          </li>}
      </ul>
      <div className="tab-container" style={{ background: '#fff' }}>
        {currentTabContents}
      </div>
    </div>
  );
};

const defaultDropdownStyle = {};

type MultiTabDropdownProps = DropdownBodyProps & {
  // Global dropdown props
  id: string; // ID passed down to the dropdown
  open: boolean; // is the dropdown open
  disabled: boolean;
  dropdownClassName?: string; // className for the entire dropdown

  // Toggle props
  onToggleClick(e: any): void;
  toggleInnerBody: any; // contents of the toggle
};

const MultiTabDropdown: VoidFunctionComponent<MultiTabDropdownProps> = ({
  dropdownStyle = defaultDropdownStyle,
  filterEnabled = false,
  ...props
}) => (
  <Dropdown
    id={props.id}
    className={props.dropdownClassName || ''}
    open={props.open}
    disabled={props.disabled}>
    <Dropdown.Toggle
      className="text-right"
      bsRole="toggle"
      onClick={props.onToggleClick}>
      {props.toggleInnerBody}
    </Dropdown.Toggle>
    <Dropdown.Menu
      className="dropdown-menu"
      onClick={stopEventPropagation}
      onSelect={stopEventPropagation}>
      <DropdownBody
        dropdownStyle={dropdownStyle}
        filterEnabled={filterEnabled}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </Dropdown.Menu>
  </Dropdown>
);

export default MultiTabDropdown;
